import { useCallback } from 'react';
import { defaultViralSettingsHisiClient } from './ViralSettingsHisiClient';
import { ViralSettingsAnalytics } from './ViralSettingsAnalytics';
import { useAnalytics } from '../../analytics';

const useViralSettingsHaveISeenIt = () => {
	const analytics = useAnalytics(ViralSettingsAnalytics);
	const setViralSettingsHaveISeenIt = useCallback(
		(flagKey: string, product: string, domain?: string) => {
			return defaultViralSettingsHisiClient.postFlagWithAnalytics(
				{
					flagKey,
					product,
					domain,
				},
				analytics,
			);
		},
		[analytics],
	);
	return { setViralSettingsHaveISeenIt };
};

export default useViralSettingsHaveISeenIt;
